module.exports = __webpack_public_path__ + "static/media/dog-3.b096b24e.jpg";